import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCallQueue } from '../dashboard/executive/myDayData';
import { QueryState } from '../dashboard/executive/MyDaySections';
import { handOffTelephone } from './telecallerTodayTypes';

/** Personal mode of the existing call queue. Telephone handoff uses the lead screen's dial action. */
export function PersonalCallQueue() {
  const query = useCallQueue();
  const location = useLocation();
  const [search, setSearch] = useState('');
  const selected = location.state?.queueLeadId;
  return <div className="space-y-4">
    <header className="flex justify-between">
      <h1 className="text-2xl font-semibold">Call Queue</h1>
      <button className="btn" onClick={query.retry}>Refresh</button>
    </header>
    <label className="block">Search your queue<input className="input ml-3" value={search} onChange={e => setSearch(e.target.value)} />
    </label>
    {!query.data ? <QueryState label="call queue" error={query.error} retry={query.retry} /> : <>
      <p>{query.data.length} leads loaded. Your earliest follow-ups appear first.</p>
      {query.data.length === 0 ? <p>No calls waiting in your queue.</p> : <ul className="space-y-3">{[...query.data].sort((a, b) => Number(b.id === selected) - Number(a.id === selected)).filter(row => [row.contact?.firstName, row.contact?.lastName, row.contact?.phone, row.contact?.mobile].join(' ').toLowerCase().includes(search.toLowerCase())).map(row => {
        const name = [row.contact?.firstName, row.contact?.lastName].filter(Boolean).join(' ') || 'Contact name not recorded';
        const phone = row.contact?.phone || row.contact?.mobile;
        return <li key={row.id} className={`card p-4 flex justify-between items-center ${row.id === selected ? 'ring-2 ring-orange-400' : ''}`}>
          <div>
            <strong>{name}</strong>
            <p>{phone || 'Phone not recorded'}</p>
            <p className="text-sm">{row.contact?.city || 'City not recorded'} · Priority {row.priority}</p>
          </div>
          <button className="btn" disabled={!phone} aria-label={`Call ${name}`} onClick={() => { if (phone) handOffTelephone(phone); }}>Call</button>
        </li>;
      })}</ul>}
    </>}
  </div>;
}
